<template>
  <b-form id="login-form">
    <b-card header="Anmeldung" no-body>
      <b-card-body id="login">
        <p>Hier kannst du dich anmelden, um die erweiterten Funktionen der Website nutzen zu
          können. Dazu benötigst du nur deinen <strong>persönlichen Zugangscode</strong>, den du
          auf deiner Einladung findest. Bitte achte auf Groß- und Kleinschreibung.</p>

        <b-form-group label="Zugangscode" label-for="access-code" label-cols-lg="2"
                      label-cols-sm="3">
          <b-input id="input-access-code" placeholder="Zugangscode" v-model="accessCode"
                   type="password" required :state="accessCodeValidation && !wrongToken"
                   :disabled="loading"/>
          <b-form-invalid-feedback :state="accessCodeValidation">
            Der Zugangscode besteht aus 16 Zeichen (a-z, A-Z, 0-9).
          </b-form-invalid-feedback>
          <b-form-invalid-feedback :state="!wrongToken">
            Der eingegebene Zugangscode ist leider falsch.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-card-body>

      <b-card-footer id="buttons">
        <b-button id="reset" variant="danger" :disabled="loading" @click="accessCode = ''">
          Zurücksetzen
        </b-button>
        <b-button id="submit" variant="success" :disabled="loading" @click="login">
          <b-spinner small variant="light" v-if="loading" />
          Anmelden
        </b-button>
      </b-card-footer>
    </b-card>
  </b-form>
</template>

<script>
export default {
  name: 'LoginForm',

  data() {
    return {
      accessCode: '',
      intent: '',
      wrongToken: false,

      loading: false,
    };
  },

  computed: {
    accessCodeValidation() {
      return /[a-zA-Z0-9]{16}/.test(this.accessCode);
    },
  },

  methods: {
    login() {
      this.loading = true;

      this.$http.post(`/authenticate?token=${this.accessCode}`)
        .then(this.redirect)
        .catch((error) => {
          this.loading = false;

          if (error.response && error.response.status === 401) {
            this.wrongToken = true;
          }
        });
    },

    redirect(response) {
      this.loading = false;

      if (this.$route.query.intent) {
        this.$router.push(this.$route.query.intent);
      } else {
        this.$router.push('/galerie');
      }
    },
  },

  mounted() {
    if (this.$route.query.intent) {
      this.intent = this.$route.query.intent;
    }

    if (this.$route.query.token) {
      this.accessCode = this.$route.query.token;

      if (this.accessCode.length === 16) {
        this.login();
      }
    }
  },
};
</script>

<style lang="scss">
  #login {
    border-bottom: 1px solid rgb(0, 0, 0, 0.125);
    background-color: $body-bg;
  }

  #buttons {
    text-align: right;
    border-top: none;

    button {
      margin-left: 1rem;

      .spinner-border {
        position: relative;
        top: -1px;

        margin-right: 0.35rem;
      }
    }
  }

  .invalid-feedback:not(.d-block) {
    display: none !important;
  }
</style>
